import axios from "axios";
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import qs from 'qs';

/**
 * Property self-service for adding LoRa devices from the property's corporate
 * group's linked organisations. Gated to property owners/admins on the API.
 */
export const corporateLoraDeviceService = {
  getDevices,
  add,
};

/**
 * LoRa devices available to a property (from its corporate group's linked
 * organisations). Returns { code, linked, data } or null.
 */
function getDevices(propertyId) {
  const query = qs.stringify({ property_id: propertyId }, { addQueryPrefix: true });
  return axios
    .get(`${apiEndpoint.corporateLoraDevices}${query}`, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : null))
    .catch((err) => (err.response ? err.response.data : null));
}

/**
 * Add a chosen LoRa device to a property.
 * @param {number} propertyId
 * @param {{terminal_id:string|number, part_number:Array, name:string}} sensor
 */
function add(propertyId, sensor) {
  return axios
    .post(
      apiEndpoint.corporateLoraDevices,
      { property_id: propertyId, sensor },
      { headers: authHeader() }
    )
    .then((res) => (res && res.status === 200 ? res.data : null))
    .catch((err) => (err.response ? err.response.data : null));
}
